export class OtrosExclusionEntity
    {
        constructor(
        public CodigoUsuario?: number,
        public CodigoPoliza?: string,
        public CodigoCiudad?: number,
        public CodigoRamo?: string,
        public CodigoAseguradora?: number,
        public RolEmpleado?: number,
        public CodigoUnidad?: number,        
        public CodigoCliente?: number,
        public BienAsegurado?: string,        
        public Observaciones?: string
        ){}        
    }

    export class DatosFacturaEntity
    {
        constructor(
        public  FacturaOtraPersona?: boolean,
        public  NombreFac?: string,
        public  IdentificacionFac ?: string,
        public  Telefono ?: string,
        public  EmailFac?: string,
        public  FechaVigencia?: Date,
        public  Comentarios?:string
        ){}

    }
    export class DatosInspeccionEntity
    {    
        constructor(    
        public  Nombres ?: string,       
        public  Telefono ?: string  
        ){}    

    }


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/entities/otros_exclusion_entity.ts